var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"className":"st0","points":"410.1,122.1 381.9,93.9 252,223.7 122.1,93.9 93.9,122.1 223.7,252 93.9,381.9 122.1,410.1 252,280.3 \n\t381.9,410.1 410.1,381.9 280.3,252 "}));
}

CloseIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 504 504","style":{"enableBackground":"new 0 0 504 504"},"xmlSpace":"preserve"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
